import { Typography } from "./typography";

export type TextListItem = {
  title: string;
  description?: string;
  value: string;
  valueDescription?: string;
};

type TextListProps = {
  title: string;
  fallbackTitle: string;
  items: TextListItem[];
};

/**
 * Renders a list of text items with a fixed title and consistent spacing
 */
export const TextList = ({ title, fallbackTitle, items }: TextListProps) => {
  const displayTitle = items.length === 0 ? fallbackTitle : title;

  return (
    <div className="w-full">
      <Typography size="sm" weight="bold">
        {displayTitle}
      </Typography>

      <div className="border-border-primary mt-2 border-b" />

      <div className="space-y-1">
        {items.map((item, index) => (
          <div key={index}>
            <div className="flex items-start justify-between py-2">
              <div className="flex-1">
                <Typography size="sm" weight="bold">
                  {item.title}
                </Typography>
                {item.description && (
                  <Typography size="sm" color="neutral" className="mt-1">
                    {item.description}
                  </Typography>
                )}
              </div>

              <div className="ml-4 flex flex-col items-end text-right">
                <Typography size="sm" weight="bold">
                  {item.value}
                </Typography>
                {item.valueDescription && (
                  <Typography size="sm" color="neutral" className="mt-1">
                    {item.valueDescription}
                  </Typography>
                )}
              </div>
            </div>

            {index < items.length - 1 && (
              <div className="border-border-primary border-b" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
